import { render, staticRenderFns } from "./ProgramActivityReminderView.vue?vue&type=template&id=2b86b7b4"
import script from "./ProgramActivityReminderView.vue?vue&type=script&lang=js"
export * from "./ProgramActivityReminderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports